import { DEFAULT_ACTIVE_ANALYTICS } from 'constants/analytic/analytic';

import { AnalyticSystems } from 'interfaces/Analytic/analytic';

export const excludeAnalyticsSystems = (systems: AnalyticSystems[]): AnalyticSystems[] =>
    DEFAULT_ACTIVE_ANALYTICS.filter((el) => !systems.includes(el));
